/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Alter_R1_ErrorInputs */



/**
* | output |
* | --- |
* | "Cannot save: predator-prey repeat (R1 violation)." |
*
* @param {Rounds_Alter_R1_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_alter_r1_error = /** @type {((inputs?: Rounds_Alter_R1_ErrorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Alter_R1_ErrorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible d'enregistrer : répétition prédateur-proie (violation R1).")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se puede guardar: repetición depredador-presa (violación R1).")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não é possível salvar: repetição predador-presa (violação R1).")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile salvare: ripetizione predatore-preda (violazione R1).")
	return /** @type {LocalizedString} */ ("Cannot save: predator-prey repeat (R1 violation).")
});